// extracted by mini-css-extract-plugin
module.exports = {"grow":"Grow_grow__vuIHs","hide":"Grow_hide__RYhok","show":"Grow_show__Kn_fc","transitionbox1":"Grow_transitionbox1__p9jh4","transitionbox2":"Grow_transitionbox2__X6o1y"};